import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "recensement-form-container" }
const _hoisted_2 = { class: "form-section" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-actions" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-save"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "header-section" }, [
      _createElementVNode("h1", { class: "page-title" }, [
        _createElementVNode("i", { class: "fas fa-user-plus" }),
        _createTextVNode(" Enregistrement d'un Nouvel Usager ")
      ]),
      _createElementVNode("p", { class: "page-subtitle" }, "Complétez les informations de l'usager à recenser")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "recensementForm",
          onSubmit: _ctx.submitForm,
          "validation-schema": _ctx.recensementSchema
        }, {
          default: _withCtx(() => [
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "form-section-title" }, [
              _createElementVNode("h3", null, [
                _createElementVNode("i", { class: "fas fa-user" }),
                _createTextVNode(" Informations personnelles")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label required" }, "Nom", -1)),
                _createVNode(_component_Field, {
                  name: "nom",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom de famille",
                  modelValue: _ctx.formData.nom,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nom) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nom",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label required" }, "Prénom", -1)),
                _createVNode(_component_Field, {
                  name: "prenom",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Prénom",
                  modelValue: _ctx.formData.prenom,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.prenom) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "prenom",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "Date de naissance", -1)),
                _createVNode(_component_Field, {
                  name: "dateNaissance",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.formData.dateNaissance,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dateNaissance) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateNaissance",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Sexe", -1)),
                _createVNode(_component_Field, { name: "sexe" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps(field, {
                      options: _ctx.sexeOptions,
                      searchable: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "preserve-search": false,
                      placeholder: "Sélectionnez le sexe",
                      class: "form-control shadow-none fs-md-15 text-black",
                      modelValue: _ctx.formData.sexe,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.sexe) = $event))
                    }), null, 16, ["options", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "sexe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label" }, "Téléphone", -1)),
                _createVNode(_component_Field, {
                  name: "telephone",
                  type: "tel",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Numéro de téléphone",
                  modelValue: _ctx.formData.telephone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.telephone) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Email", -1)),
                _createVNode(_component_Field, {
                  name: "email",
                  type: "email",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Adresse email",
                  modelValue: _ctx.formData.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label" }, "Adresse", -1)),
              _createVNode(_component_Field, {
                name: "adresse",
                as: "textarea",
                class: "form-control shadow-none fs-md-15 text-black",
                rows: "3",
                placeholder: "Adresse complète",
                modelValue: _ctx.formData.adresse,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.adresse) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "adresse",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label" }, "Lieu de naissance", -1)),
                _createVNode(_component_Field, {
                  name: "lieuNaissance",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Lieu de naissance",
                  modelValue: _ctx.formData.lieuNaissance,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.lieuNaissance) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "lieuNaissance",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label" }, "Nationalité", -1)),
                _createVNode(_component_Field, {
                  name: "nationalite",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nationalité",
                  modelValue: _ctx.formData.nationalite,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.nationalite) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nationalite",
                  class: "text-danger"
                })
              ])
            ]),
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "form-section-title" }, [
              _createElementVNode("h3", null, [
                _createElementVNode("i", { class: "fas fa-briefcase" }),
                _createTextVNode(" Informations professionnelles")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label" }, "NPI", -1)),
                _createVNode(_component_Field, {
                  name: "npiUsager",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Numéro d'identification professionnelle",
                  modelValue: _ctx.formData.npiUsager,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.npiUsager) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "npiUsager",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label" }, "IFU", -1)),
                _createVNode(_component_Field, {
                  name: "ifu",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Identifiant fiscal unique",
                  maxlength: "13",
                  modelValue: _ctx.formData.ifu,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.ifu) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "ifu",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label" }, "Raison sociale", -1)),
                _createVNode(_component_Field, {
                  name: "raisonSocial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Raison sociale de l'entreprise",
                  modelValue: _ctx.formData.raisonSocial,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.raisonSocial) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "raisonSocial",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, "Dénomination", -1)),
                _createVNode(_component_Field, {
                  name: "denomination",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Dénomination commerciale",
                  modelValue: _ctx.formData.denomination,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.denomination) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "denomination",
                  class: "text-danger"
                })
              ])
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "form-section-title" }, [
              _createElementVNode("h3", null, [
                _createElementVNode("i", { class: "fas fa-map-marker-alt" }),
                _createTextVNode(" Informations d'emplacement")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label" }, "Code emplacement", -1)),
              _createVNode(_component_Field, {
                name: "codeemp",
                type: "text",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Code de l'emplacement",
                modelValue: _ctx.formData.codeemp,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.codeemp) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "codeemp",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label" }, "Date de recensement", -1)),
              _createVNode(_component_Field, {
                name: "dateRecensement",
                type: "date",
                class: "form-control shadow-none fs-md-15 text-black",
                modelValue: _ctx.formData.dateRecensement,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.dateRecensement) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateRecensement",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "btn btn-secondary",
                disabled: _ctx.isSubmitting
              }, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
                _createTextVNode(" Retour ", -1)
              ]))], 8, _hoisted_26),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.isSubmitting
              }, [
                (_ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                  : (_openBlock(), _createElementBlock("i", _hoisted_29)),
                _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : 'Enregistrer'), 1)
              ], 8, _hoisted_27)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}